export const hdmgdjScreenshots = [
  {
    id: "shot-home",
    index: "01",
    title: "首页推荐",
    tag: "发现",
    desc: "搜索、频道分类与精选原创一屏直达，金币福利随手就能领。",
    image: "/images/screenshot-1.jpeg",
  },
  {
    id: "shot-featured",
    index: "02",
    title: "精选片库",
    tag: "选片",
    desc: "大神精选、单体作品、影视魔改三大频道，热度口碑一目了然。",
    image: "/images/screenshot-2.jpeg",
  },
  {
    id: "shot-topic",
    index: "03",
    title: "短剧专题",
    tag: "合集",
    desc: "编辑部精选合集，都市、古装、情感一次看个够。",
    image: "/images/screenshot-3.jpeg",
  },
  {
    id: "shot-urge",
    index: "04",
    title: "催更中心",
    tag: "互动",
    desc: "亮出你的态度，投票催更，让喜欢的作品更新得更快。",
    image: "/images/screenshot-4.jpeg",
  },
  {
    id: "shot-wish",
    index: "05",
    title: "心愿榜单",
    tag: "榜单",
    desc: "魔改愿望榜全民投票，呼声最高的作品率先开拍。",
    image: "/images/screenshot-5.jpeg",
  },
];